/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ contextType: NonNullable<unknown> }} Task_Context_Type_LabelInputs */

const en_task_context_type_label = /** @type {(inputs: Task_Context_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.contextType === "case") return /** @type {LocalizedString} */ (`Case`);
	if (i?.contextType === "client") return /** @type {LocalizedString} */ (`Client`);
	return /** @type {LocalizedString} */ (`${i?.contextType}`)
	
};

const pt_br2_task_context_type_label = /** @type {(inputs: Task_Context_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.contextType === "case") return /** @type {LocalizedString} */ (`Caso`);
	if (i?.contextType === "client") return /** @type {LocalizedString} */ (`Cliente`);
	return /** @type {LocalizedString} */ (`${i?.contextType}`)
	
};

/**
* | contextType | output |
* | --- | --- |
* | "case" | "Case" |
* | "client" | "Client" |
* | * | "{contextType}" |
*
* @param {Task_Context_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_context_type_label = /** @type {((inputs: Task_Context_Type_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Context_Type_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_context_type_label(inputs)
	return pt_br2_task_context_type_label(inputs)
});